import { AppDispatch } from '../index';
import { apiQuery } from 'helpers/query';
import { getAnalyticsQuery, getDigestAnalyticsQuery, IAnalytics } from 'api/analytics';
import { AnalyticsActionTypes } from '../types/analyticsActionTypes';
import { UserActionTypes } from 'store/types/userActionTypes';

export const getAnalyticsData = ({ range, start, end }: IAnalytics) => {
    return async (dispatch: AppDispatch) => {
        try {
            const digestAnalyticsPromise = apiQuery(() =>
                getDigestAnalyticsQuery({
                    range,
                    start,
                    end,
                }),
            ).catch((error) => {
                console.log(error);
                return null;
            });
            const data = await apiQuery(() =>
                getAnalyticsQuery({
                    range,
                    start,
                    end,
                }),
            );

            if (!data) throw new Error('Failed to fetch');

            dispatch({
                type: AnalyticsActionTypes.FETCHING_ANALYTICS_DATA,
                payload: data,
            });

            const digestAnalytics = await digestAnalyticsPromise;
            if (digestAnalytics) {
                dispatch({
                    type: AnalyticsActionTypes.FETCHING_ANALYTICS_DATA,
                    payload: {
                        ...data,
                        digestAnalytics,
                    },
                });
            }
        } catch (error) {
            if (error instanceof Error) {
                dispatch({
                    type: UserActionTypes.FETCH_ERROR,
                    payload: error.message,
                });
            }
        }
    };
};
